export class AdminOption {
    public AdminOptionId: number;
    public WebCategoryId: number;
    public PlantId: number;
    public ProductLineId: number;
    public OptionId: number;
    public SubOptionId: number;
    public CustomerDesc: string;
    public CustomerCat: string;
    public MaxQuantity: number;
    public Visible: boolean;
    public CustomerBaseDesc: string;
    public OptionNumber: number;

    constructor(){
        this.AdminOptionId = null;
        this.WebCategoryId = null;
        this.PlantId = null;
        this.ProductLineId = null;
        this.OptionId = null;
        this.SubOptionId = null;
        this.CustomerDesc = '';
        this.CustomerBaseDesc = '';
        this.CustomerCat = '';
        this.MaxQuantity = 0;
        this.Visible = true;
        this.OptionNumber = null;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/admin-option.ts